module.exports = __webpack_public_path__ + "static/media/franchise03.3b9a0f1d.png";